import { InjectionToken } from '@angular/core';

export const API_PREFIX = new InjectionToken<string>('API_PREFIX');
export const CONFIG_LOADED = new InjectionToken<Promise<void>>('CONFIG_LOADED');
export const KEYCLOAK_INITIALIZED = new InjectionToken<Promise<void>>('KEYCLOAK_INITIALIZED');
export const RIO_INITIALIZED = new InjectionToken<Promise<void>>('RIO_INITIALIZED');
